import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface RevenueModal {
	title: string;
	proposalRevenueDocument: string;
	indice: number;
	isUserOwner: boolean;
}

@Component({
	selector: 'revenue-modal',
	templateUrl: './revenue-modal.component.html',
	styleUrls: ['./revenue-modal.component.scss']
})
export class RevenueModalComponent extends DialogComponent<RevenueModal, boolean> implements RevenueModal {
	title: string;
	proposalRevenueDocument: string;
	indice: number;
	isUserOwner: boolean;

	constructor(dialogService: DialogService) {
		super(dialogService);
	}

	saveReceita(confirm) {
		$("#tempPotencialReceitaGrupo").val(Number($("#receitaTotalCalculado").val()));

		if (confirm) {
			this.confirm();
		} else {
			this.close();
		}
	}

	confirm() {
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/revenue-modal/revenue-modal.component.ts